export const SEO_CONSTANTS = {
    DEFAULT_TITLE: 'ChilePasajes - Compra tus pasajes en línea',
    DEFAULT_DESCRIPTION: 'Encuentra y compra pasajes de bus en línea. Viaja por Chile de forma segura y cómoda.',
    DEFAULT_KEYWORDS: 'pasajes, bus, chile, viajes, transporte',

    ROUTES: {
        DESTINOS: {
            titulo: "Pasajes en Bus a [ciudad] | Compra en ChilePasajes.cl",
            descripcion: "Descubre la amplia variedad de empresas de buses y horarios en la compra online de tus pasajes a [ciudad]. ¡Compra fácil y seguro en ChilePasajes.cl!",
            ctas: [
                " ¡Compra tu pasaje al mejor precio!",
            ]
        },
        RUTAS: {
            titulo: "Pasajes de [ciudad 1] a [ciudad 2] en Bus ¡Compra a Precios Baratos!",
            descripcion: "Compra online tus pasajes de [ciudad 1] hacia [ciudad 2] en Bus aquí. Encuentra los precios más baratos disponibles para tu viaje. [CTA]",
            ctas: [
                "¡Compra tu pasaje online!",
            ]
        },
        TERMINALES: {
            titulo: "[terminal] | Compra en ChilePasajes.cl",
            descripcion: "Revisa la información que necesitas conocer sobre rutas frecuentes, servicios, dirección y contacto del    [terminal] para tu siguiente viaje. [CTA]",
            ctas: [
                "¡Planifica tu viaje hoy mismo!",
            ]
        },
        EMPRESAS: {
            titulo: "[empresa buses] | Compras en ChilePasajes.cl",
            descripcion: "Viajar junto a [empresa buses] es sencillo y seguro. Ingresa el destino, la fecha y compara las alternativas. [CTA]",
            ctas: [
                "¡Compra tus pasajes de bus al mejor precio!",
            ],
            faq: [
                {
                    pregunta: "¿Cómo puedo comprar pasajes online con [empresa buses]?",
                    respuesta: "Puedes comprar tus pasajes de forma rápida y segura a través de nuestro sitio web. Solo debes seleccionar tu origen, destino, fecha de viaje y completar los datos de los pasajeros. Luego, realiza el pago y recibirás tu pasaje por correo electrónico. "
                },
                {
                    pregunta: "¿Qué debo hacer si ingresé mal los datos de mi pasaje? ",
                    respuesta: "Si cometiste un error al ingresar tus datos, puedes corregirlos contactando a nuestro servicio de atención al cliente a través de nuestro formulario de contacto o llamando a nuestra central de ayuda."
                },
                {
                    pregunta: "No recibí el comprobante de mis pasajes, ¿cómo puedo pedir una copia a [empresa buses]? ",
                    respuesta: "Si no has recibido tu pasaje en tu correo electrónico, revisa tu carpeta de spam. Si aún no lo encuentras, puedes solicitar una copia ingresando a tu cuenta en nuestro sitio web o contactándonos directamente. "
                },
                {
                    pregunta: "¿Cómo es el proceso de cambio de pasajes con [empresa buses]?",
                    respuesta: "Para realizar un cambio de pasaje, debes ingresar a nuestra sección de gestión de pasajes en línea o acudir a una de nuestras oficinas. Los cambios están sujetos a disponibilidad y pueden aplicarse cargos adicionales según nuestras políticas. "
                },
                {
                    pregunta: "¿Cómo es el proceso de anulación de pasajes en [empresa buses]?",
                    respuesta: "Puedes anular tu pasaje según nuestras políticas de cancelación. Debes hacerlo con al menos 4 horas de anticipación antes de la salida del bus, ya sea en línea o en nuestras oficinas. Las devoluciones pueden estar sujetas a cargos administrativos.  "
                },
                {
                    pregunta: "¿Qué debo hacer si tuve problemas con el proceso de pago y necesito una devolución? ",
                    respuesta: "Si experimentaste un problema durante el pago y el monto fue descontado de tu cuenta, contáctanos de inmediato con el comprobante de pago para gestionar la devolución o solución correspondiente. "
                },
                {
                    pregunta: "¿Puedo viajar con mi mascota en [empresa buses]?",
                    respuesta: "Sí, puedes viajar con tu mascota bajo ciertas condiciones. Dependiendo del tipo de bus y la normativa vigente, es posible que debas transportarla en un contenedor adecuado y presentar la documentación sanitaria requerida."
                },
                {
                    pregunta: "¿Cuáles son las paradas que realiza el bus durante el viaje [empresa buses]? ",
                    respuesta: "Las paradas varían según la ruta seleccionada. Puedes revisar el itinerario completo de tu viaje en la descripción de la ruta al momento de comprar tu pasaje o consultando a nuestro servicio de atención al cliente. "
                },
                {
                    pregunta: "¿De qué manera [empresa buses] informa la suspensión del servicio?",
                    respuesta: "En caso de suspensión del servicio por razones climáticas u operacionales, notificaremos a los pasajeros a través de correo electrónico, mensajes de texto y nuestras redes sociales oficiales. "
                },
                {
                    pregunta: "¿Dónde se ubican los puntos de subida en Santiago de [empresa buses]? ",
                    respuesta: "Nuestros buses tienen puntos de salida en diversas terminales de Santiago. Puedes consultar la ubicación exacta en tu pasaje o en la sección \"Terminales\" de nuestro sitio web. "
                },
            ]
        }
    }
}